import { useDeploymentWizard } from '@/stores/deploymentWizard'
import { hasWorkwise, selectionNoticeMessage } from '@/utils/workwise/selection'

/** Whether WorkWise is selected in the product picker, and the notice to show. */
export function useWorkwiseSelection() {
  const selectedProducts = useDeploymentWizard((s) => s.selectedProducts)
  const notice = useDeploymentWizard((s) => s.selectionNotice)
  const workwiseSelected = hasWorkwise(selectedProducts)
  return {
    workwiseSelected,
    notice,
    message: selectionNoticeMessage(notice, workwiseSelected),
  }
}
